export const order = {

  namespaced: true,

  state: {
    newOrders: 0,
  },

  actions: {
    query({commit}, payload) {
      commit('updateQuery', payload);
    }
  },

  mutations: {
    updateQuery(state, payload) {
      state.newOrders = payload
    }
  }
};
